'use strict';

var React = require('react');
var useMatchDevice = require('../../hooks/useMatchDevice.js');
require('imask');
var useIsomorphicLayoutEffect = require('../../hooks/useIsomorphicLayoutEffect.js');
var useResizeObserver = require('../../hooks/useResizeObserver.js');
var useWindowResize = require('../../hooks/useWindowResize.js');

const getPositionTop = ({ dialog, documentHeight }) => {
    const dialogHeight = dialog.clientHeight;
    const dialogHalfHeight = Math.round(dialogHeight / 2);
    const documentHalfHeight = Math.round(documentHeight / 2);
    const positionTop = documentHalfHeight - dialogHalfHeight;
    return positionTop;
};
const usePositionTop = ({ dialogRef, isOpened }) => {
    const html = React.useMemo(() => globalThis.document?.querySelector('html') || null, []);
    const [top, setTop] = React.useState(null);
    const isMobile = useMatchDevice.useMatchDevice('mobile');
    const setComputedTop = React.useCallback(() => {
        const dialog = dialogRef.current;
        if (!isOpened || !dialog || !html || isMobile) {
            setTop(null);
            return;
        }
        const nextTop = getPositionTop({ dialog, documentHeight: html.clientHeight });
        setTop(nextTop);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpened, isMobile, html, dialogRef.current]);
    useIsomorphicLayoutEffect.useIsomorphicLayoutEffect(setComputedTop, [setComputedTop]);
    useWindowResize.useWindowResize({ listener: setComputedTop });
    useResizeObserver.useResizeObserver({
        elementRefs: [dialogRef, React.useRef(html)],
        observer: setComputedTop,
    });
    return top;
};

exports.usePositionTop = usePositionTop;
//# sourceMappingURL=usePositionTop.js.map
